import FileWithContext from '../../../models/file_with_context'

const types = Object.values(FileWithContext.TYPE)
  .map((id) =>
    typeof id === 'string'
      ? {
          id: id,
          name: `hs.file.type.${id}`,
        }
      : Object.values(id).map((sub_id) => ({
          id: sub_id,
          // Improve the subkey function in order to get the parent name
          name: `hs.file.type.contract.${sub_id}`,
        }))
  )
  .flat()
const categories = Object.values(FileWithContext.CATEGORY)
  .map((id) => {
    console.log({ id })
    return typeof id === 'string'
      ? {
          id: id,
          name: `hs.file.category.${id}`,
        }
      : Object.values(id).map((sub_id) => ({
          id: sub_id,
          // Improve the subkey function in order to get the parent name
          name: `hs.file.category.contract.${sub_id}`,
        }))
  })
  .flat()
export default {
  types,
  categories,
}
